import { useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from 'api'
import { useEffect } from 'react'
import { toaster } from 'uikit/Toaster'

export const useSyncUser = (id: string) => {
  const queryClient = useQueryClient()

  const response = useQuery({
    queryKey: ['useSyncUser', id],
    queryFn: () => api.users.syncUser(id),
    enabled: false,
  })

  useEffect(() => {
    if (response.isError) {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка синхронизации',
        description: (response.error as any)?.response?.data?.message || response.error?.message,
      })
    }
  }, [response.isError])

  useEffect(() => {
    if (response.isSuccess) {
      queryClient.invalidateQueries({ queryKey: ['userCard', id, 'passportJournal'] })
    }
  }, [response.isSuccess])

  return response
}
